import * as THREE from "three";
import { createLabel } from "../../../TOOLS/LabelFactory";

export class User {
  constructor(store, parent, label) {
      this.store = store;
      this.parent = parent;
      this.label = label;
      this.group = new THREE.Group();
      this.parent.add(this.group);
      this.group.position.set(0, 15, 5);
      this.targetPosition = new THREE.Vector3(0, 15, 5);
      this.targetScale = new THREE.Vector3(1, 1, 1);
      this.moveSpeed = 4;
      this.pictureChanged = false;
      this.changePictureTimer = null;
      this.createMesh();
      
  }


  createMesh() {
    const geometry = new THREE.CylinderGeometry(1, 1, 0.08, 32);
    const loader = new THREE.TextureLoader();
    const texture = loader.load("/assets/faces/xxx.png");
    texture.colorSpace = THREE.SRGBColorSpace;
    texture.center.set(0.5, 0.5);
    texture.rotation = Math.PI / 2;
    const sideMaterial = new THREE.MeshStandardMaterial({color: 0x888888, roughness: 0.35, metalness: 0.15});
    const topMaterial = new THREE.MeshStandardMaterial({color: 0x888888, roughness: 0.35, metalness: 0.15});
    const bottomMaterial = new THREE.MeshStandardMaterial({color: 0x666666});
    this.mesh = new THREE.Mesh(geometry, [sideMaterial, topMaterial, bottomMaterial]);
    this.mesh.rotation.x = THREE.MathUtils.degToRad(60);
    this.mesh.castShadow = true;
    this.mesh.receiveShadow = true;
    this.group.add(this.mesh);

    // A kép kisebb korongként kerül a cylinder tetejére
    this.topMaterial = new THREE.MeshStandardMaterial({map: texture, roughness: 0.8, metalness: 0});
    const pictureGeometry = new THREE.CircleGeometry(0.9, 32);
    this.pictureMesh = new THREE.Mesh(pictureGeometry, this.topMaterial);
    this.pictureMesh.rotation.x = THREE.MathUtils.degToRad(-30);
    this.pictureMesh.rotation.z = THREE.MathUtils.degToRad(-90);
    this.pictureMesh.position.z = 0.08;
    this.pictureMesh.castShadow = true;
    this.pictureMesh.userData.type = "AUTH";
    this.store.input.clickables.push(this.pictureMesh);
    //CLICKABLES TÖMBBŐL NEM TÖRÖLHETŐ
    this.pictureMesh.userData.baseObject = true;
    this.group.add(this.pictureMesh);

    // Név
    this.nameLabel = createLabel(this.label, {fontSize: 16, position: new THREE.Vector3(0, -1, 0)});
    this.group.add(this.nameLabel);
}

  setPicture(picture) {
      const loader = new THREE.TextureLoader();
      loader.load(`/assets/faces/${picture}`, (texture) => {
          texture.colorSpace = THREE.SRGBColorSpace;
          texture.center.set(0.5, 0.5);
          texture.rotation = Math.PI / 2;
          const oldTexture = this.topMaterial.map;
          this.topMaterial.map = texture;
          this.topMaterial.needsUpdate = true;
          if (oldTexture) {oldTexture.dispose();}
      });
  }

  setPosition(position) {this.group.position.copy(position);}

  moveTo(position, scale) {
    this.targetPosition = position.clone();
    this.targetScale = scale;
  }

  changeToActualUser() {
    const actualUser = this.store.database.actualUser;
    console.log('actualUser', actualUser)
    if (!actualUser) return;
    // Kép cseréje
    if (actualUser.picture) {this.setPicture(actualUser.picture);}
    // Régi label eltávolítása
    if (this.nameLabel) {this.group.remove(this.nameLabel);}
    // Új label
    this.nameLabel = createLabel(actualUser.name, {fontSize: 16, position: new THREE.Vector3(0, -1, 0)});
    this.group.add(this.nameLabel);
  }

    async authenticate() {
        const actualUser = this.store.database.actualUser;
        if (!actualUser) return;
        // Megvárjuk, hogy az ENTER animáció elindulhasson
        await new Promise(resolve => setTimeout(resolve, 2000));
        // Ezután jöhet a képváltás
        this.store.level.userAnimation = "CHANGEPICTURE";
    }

    update(delta) {
    const state = this.store.level.userAnimation;
    if (state === "ENTER") {
        this.pictureChanged = false;
        this.targetPosition.set(0, 5, 5);
        this.targetScale.set(2, 2, 2);
    } else if (state === "CHANGEPICTURE") {
        // Csak egyszer hajtjuk végre
        if (!this.pictureChanged) {
            this.pictureChanged = true;
            // Kép és név cseréje
            this.changeToActualUser();
            // 2 másodperc múlva induljon az elmozdulás
            this.changePictureTimer = setTimeout(() => {this.store.level.userAnimation = "AUTHENTICATED";}, 2000);
        }
        return;
    } else if (state === "AUTHENTICATED") {
        this.targetPosition.set(-18, 4, -6);
        this.targetScale.set(1, 1, 1);
    } else {return;}
    const speed = 1 - Math.exp(-this.moveSpeed * delta);
    this.group.position.lerp(this.targetPosition, speed);
    this.group.scale.lerp(this.targetScale, speed);
  }
}